var _matchBrowserPrefers;
import { createContext } from 'react';
import { matchBrowserPrefers } from "../utils/matchBrowserPrefers";
export var ThemeModeContext = /*#__PURE__*/createContext({
  appearance: 'light',
  setAppearance: function setAppearance() {},
  isDarkMode: false,
  themeMode: 'light',
  setThemeMode: function setThemeMode() {},
  browserPrefers: (_matchBrowserPrefers = matchBrowserPrefers('dark')) !== null && _matchBrowserPrefers !== void 0 && _matchBrowserPrefers.matches ? 'dark' : 'light'
});